const weekDay = ['일', '월', '화', '수', '목', '금', '토'];

const getDayKorean = (v) => {
    return weekDay[v.getDay()];
}
export default getDayKorean